/* cofcof-buy-box.js — troca de variante e de preço no bloco de compra.
 *
 * O HTML já sai do servidor com a variante padrão no input `id`, então o
 * formulário compra mesmo sem JavaScript. Este arquivo só faz o bloco reagir:
 * casa as opções escolhidas com a variante certa, mostra o preço daquela
 * variante (ou do plano de assinatura selecionado) e bloqueia o botão quando a
 * combinação não existe.
 *
 * MOEDA chega pronta do servidor pelo filtro `money`, e é assim que ela aparece
 * em todo estado normal da caixa. Há UMA exceção, e ela se justifica sozinha: o
 * total de várias assinaturas não existe no servidor, porque a quantidade só é
 * escolhida aqui. Sem ele, o maior número da tela deixava de ser o que vai ser
 * cobrado. O formatador local PROVA que serve antes de ser usado — reformata o
 * preço unitário e compara com a string que o `money` devolveu; divergiu, a
 * caixa volta ao preço do servidor. Ver `dinheiro()` e `render()`.
 *
 * O outro cálculo daqui é uma PROPORÇÃO — quantos por cento a melhor opção sai
 * mais barata por quilo —, a partir de dois campos do cadastro (preço em
 * centavos e peso em gramas), e nunca vira texto de moeda.
 */
(function () {
  'use strict';

  /* C11-09 — este arquivo é declarado pelo próprio snippet do bloco de compra,
   * para o comportamento viajar com o componente. Duas caixas na mesma página
   * emitem a tag duas vezes: o navegador baixa uma vez e EXECUTA duas. Sem a
   * marca abaixo, o segundo `init` ligaria um segundo listener de `change` (a
   * variante seria renderizada duas vezes por clique) e leria `defaultLabel` do
   * botão que o primeiro já pode ter trocado por "Esgotado" — o rótulo "Assinar
   * agora" nunca mais voltaria. */
  var MARCA = 'cofcofBuyboxPronto';

  function init(root) {
    if (root.dataset && root.dataset[MARCA] === '1') return;
    var dataEl = root.querySelector('[data-cofcof-buybox-data]');
    var form = root.querySelector('form');
    if (!dataEl || !form) return;
    if (root.dataset) root.dataset[MARCA] = '1';

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return; /* sem dados válidos, o formulário segue funcionando no modo servidor */
    }
    var variants = (data && data.variants) || [];
    if (!variants.length) return;

    var variantInput = root.querySelector('[data-cofcof-buybox-variant]');
    var priceEl = root.querySelector('[data-cofcof-buybox-price]');
    var noteEl = root.querySelector('[data-cofcof-buybox-price-note]');
    var volumeEl = root.querySelector('[data-cofcof-buybox-volume]');
    var kgEl = root.querySelector('[data-cofcof-buybox-price-kg]');
    var multEl = root.querySelector('[data-cofcof-buybox-price-mult]');
    var dicaEl = root.querySelector('[data-cofcof-buybox-dica]');
    var qtyEl = root.querySelector('input[name="quantity"]');
    /* C11-09 rodada 1 — UM lugar decide qual quantidade é válida.
     *
     * Antes o piso e o teto estavam copiados em três handlers (`input` via
     * `render`, `blur` e `submit`), e o `render` era o único que não aplicava o
     * teto. Foi assim que a tela exibiu R$ 42.707,25 enquanto o carrinho
     * recebia R$ 4.232,25. Regra copiada em três lugares diverge em um deles;
     * é sempre uma questão de tempo. */
    function quantidadeValida() {
      var n = qtyEl ? parseInt(qtyEl.value, 10) : 1;
      var teto = qtyEl ? parseInt(qtyEl.getAttribute('max'), 10) : NaN;
      if (!isFinite(n) || n < 1) return 1;
      if (isFinite(teto) && n > teto) return teto;
      return n;
    }

    var submitEl = root.querySelector('[data-cofcof-buybox-submit]');
    var submitLabelEl = root.querySelector('[data-cofcof-buybox-submit-label]');
    var unavailableEl = root.querySelector('[data-cofcof-buybox-unavailable]');
    /* Mesmo formatador do `cofcof-minicart.js`, de propósito: o painel que abre
     * depois da compra e a caixa que a antecede não podem escrever o mesmo
     * dinheiro de dois jeitos. Quem decide se ele pode ser usado é a comparação
     * com o `money` do servidor, feita no `render()`. */
    function dinheiro(centavos) {
      /* ⚠️ `Intl` separa "R$" do número com ESPAÇO INSEPARÁVEL (U+00A0); o filtro
       * `money` da Shopify usa espaço comum. Visualmente idêntico, diferente para
       * `===` — foi assim que uma comparação de moeda já falhou em silêncio neste
       * repositório. Normalizado aqui para que a caixa escreva o mesmo caractere
       * que o servidor escreve no resto da página. */
      return (centavos / 100)
        .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        /* O NBSP vai por ESCAPE, nunca colado: o caractere literal é invisível
         * no editor e some numa edição sem ninguém ver. Esta linha já nasceu
         * assim uma vez, com um espaço comum no lugar dele — um replace que não
         * trocava nada e uma comparação de moeda que falhava calada. */
        .replace(/\u00a0/g, ' ');
    }

    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-cofcof-option-index]'));
    var planInputs = Array.prototype.slice.call(root.querySelectorAll('[data-cofcof-plan]'));

    /* C11-09 — o rótulo padrão vem de um atributo, NUNCA do texto renderizado.
     * Lendo o texto, quando o servidor entregasse a variante padrão sem estoque
     * o span já vinha escrito "Combinação indisponível", e era isso que virava o
     * rótulo padrão: a pessoa escolhia uma combinação boa e o botão continuava
     * dizendo que não dava para comprar. Só aparece quando o estoque acaba, que
     * é quando ninguém está olhando. */
    var defaultLabel = (submitLabelEl && submitLabelEl.getAttribute('data-label-padrao'))
      || (submitLabelEl ? submitLabelEl.textContent.trim() : 'Adicionar ao carrinho');

    function selectedOptions() {
      return groups.map(function (group) {
        var checked = group.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    function selectedPlanId() {
      for (var i = 0; i < planInputs.length; i++) {
        /* C11-09 — quando existe UM plano só, ele não é rádio: é um campo
         * oculto, porque uma pergunta com uma resposta não é pergunta. Campo
         * oculto nunca tem `checked`, e sem esta linha o preço cairia para o
         * valor da variante avulsa enquanto o pedido seguiria como assinatura —
         * a tela mentiria sobre o que vai ser cobrado. */
        if (planInputs[i].type === 'hidden') return planInputs[i].value;
        if (planInputs[i].checked) return planInputs[i].value;
      }
      return '';
    }

    function findVariant(chosen) {
      if (!chosen.length) return variants[0];
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var hit = true;
        for (var j = 0; j < chosen.length; j++) {
          if (chosen[j] !== null && v.options[j] !== chosen[j]) { hit = false; break; }
        }
        if (hit) return v;
      }
      return null;
    }

    /* C11-09 — a opção esgotada precisa AVISAR antes do clique.
     *
     * Medido forçando `available: false`: a pílula da moagem esgotada ficava
     * idêntica às disponíveis (`border rgba(246,241,235,.28)`, `opacity 1`). A
     * pessoa só descobria depois de escolher, e o botão morria na mão dela.
     *
     * "Esgotada" aqui é relativa à escolha atual: `Fina (espresso)` pode existir
     * em 2 × 250 g e faltar em 4 × 250 g. Por isso a checagem substitui UM valor
     * por vez, mantendo os outros — é a pergunta que a pessoa está fazendo. */
    function marcarEsgotadas() {
      var atual = selectedOptions();
      groups.forEach(function (group, idx) {
        var radios = group.querySelectorAll('input[type="radio"]');
        for (var i = 0; i < radios.length; i++) {
          var hipotese = atual.slice();
          hipotese[idx] = radios[i].value;
          var v = findVariant(hipotese);
          var esgotada = !v || !v.available;
          if (esgotada) {
            radios[i].setAttribute('data-esgotada', '');
            /* O leitor de tela recebe a mesma informação que o olho recebe.
             * Trocar o nome acessível é reversível e não mexe no DOM do rótulo. */
            radios[i].setAttribute('aria-label', radios[i].value + ' (indisponível)');
          } else {
            radios[i].removeAttribute('data-esgotada');
            radios[i].removeAttribute('aria-label');
          }
        }
      });
    }

    /* C11-09 — a opção de melhor valor parecia a pior.
     *
     * A caixa mostrava o preço por quilo mudando e não dizia o que significa: o
     * número absoluto SOBE de R$ 189,90 para R$ 229,90 e a pessoa lê "mais
     * caro", quando o quilo cai de R$ 379,80 para R$ 229,90 — 39% mais barato.
     *
     * Tudo aqui é aritmética entre dois campos do cadastro (centavos e gramas).
     * Some quando o peso não está cadastrado, quando não há alternativa melhor e
     * quando a melhor já está escolhida — nunca insiste no óbvio. */
    /* O preço que vale é o que vai ser COBRADO: com plano escolhido, o do plano.
     * Comparar preço avulso enquanto o pedido sai como assinatura daria uma
     * porcentagem que não corresponde a nada na fatura. */
    function centavosDe(v, planId) {
      if (planId && v.plansCent && typeof v.plansCent[planId] === 'number') return v.plansCent[planId];
      return v.centavos;
    }

    function porGrama(v, planId) {
      if (!v || !v.available || !v.gramas || v.gramas <= 0) return null;
      var c = centavosDe(v, planId);
      return typeof c === 'number' ? c / v.gramas : null;
    }

    /* C11-09 — reservar o espaço em vez de esconder.
     *
     * Medido em 393: trocar `2 × 250 g` por `4 × 250 g` encolhia a caixa de 956
     * para 921 — **35px** — porque a dica saía do fluxo. Tudo abaixo subia,
     * inclusive "Assinar agora": o texto que convence a pessoa a subir de plano
     * movia o botão de compra DEBAIXO DO DEDO dela, no instante do toque.
     *
     * `hidden` só continua sendo usado quando a dica não pode existir naquele
     * produto (sem peso, ou sem alternativa mais barata em lugar nenhum) — aí
     * reservar linha seria deixar um buraco permanente por nada. */
    /* C11-09 — o TEXTO da dica não muda; só a visibilidade muda.
     *
     * Reservar altura por `min-height` não resolveu sozinho: em 1024 a coluna é
     * mais estreita e a frase ocupa três linhas, então a reserva de duas ficava
     * 31px curta e o botão voltava a saltar. A saída é não deixar a altura
     * depender do estado: a frase é escrita UMA vez, a partir da melhor opção do
     * catálogo, e o que alterna é `visibility`. Mesma caixa, mesma altura, em
     * qualquer largura — salto zero por construção, não por ajuste de número.
     *
     * `visibility: hidden` também tira a linha do leitor de tela, então ninguém
     * ouve uma recomendação que não vale para a escolha atual. */
    function melhorDoCatalogo(planId) {
      var melhor = null, melhorKg = null;
      for (var i = 0; i < variants.length; i++) {
        var g = porGrama(variants[i], planId);
        if (g !== null && (melhorKg === null || g < melhorKg)) { melhor = variants[i]; melhorKg = g; }
      }
      return melhor ? { v: melhor, kg: melhorKg } : null;
    }

    function dicaDeValor(atual, planId) {
      if (!dicaEl) return;
      var meuKg = porGrama(atual, planId);
      var top = melhorDoCatalogo(planId);

      if (!top || !meuKg) { dicaEl.hidden = true; return; }

      /* O texto é sempre "<melhor opção> sai N% mais barato por quilo", onde N
         compara a melhor com a PIOR do catálogo — número estável, independente
         do que está marcado agora. */
      var pior = null, piorKg = null;
      for (var k = 0; k < variants.length; k++) {
        var g2 = porGrama(variants[k], planId);
        if (g2 !== null && (piorKg === null || g2 > piorKg)) { pior = variants[k]; piorKg = g2; }
      }
      if (!pior || piorKg <= top.kg) { dicaEl.hidden = true; return; }

      var eixo = -1;
      for (var m = 0; m < top.v.options.length; m++) {
        if (top.v.options[m] !== pior.options[m]) { eixo = m; break; }
      }
      if (eixo < 0) { dicaEl.hidden = true; return; }

      var queda = Math.round((1 - top.kg / piorKg) * 100);
      if (queda < 1) { dicaEl.hidden = true; return; }

      dicaEl.hidden = false;
      dicaEl.textContent = top.v.options[eixo] + ' sai ' + queda + '% mais barato por quilo.';

      /* C11-09 — a dica precisa ficar JUNTO do passo de que ela fala.
       *
       * Medido em 393: a frase "4 × 250 g sai 39% mais barato por quilo." — que
       * é sobre o passo 1, QUANTIDADE — ficava a 15px abaixo do passo 2,
       * MOAGEM, enquanto o vão entre um grupo e outro é de 28px. Ela estava
       * mais perto do grupo errado do que os grupos estão um do outro, e
       * proximidade é o que decide pertencimento: lia-se como se alguma moagem
       * fosse mais barata por quilo, o que é falso.
       *
       * O eixo não é fixo — sai da comparação entre a melhor e a pior variante
       * do catálogo —, então o lugar da dica também não pode ser fixo. Ela vai
       * para dentro do fieldset do eixo que ela cita. Mover só quando o pai
       * muda evita mexer no DOM a cada render. */
      var grupo = root.querySelector('fieldset[data-cofcof-option-index="' + eixo + '"]');
      if (grupo && dicaEl.parentNode !== grupo) grupo.appendChild(dicaEl);

      /* Já está na melhor? A linha continua ocupando o lugar, invisível. */
      var jaEstaNoMelhor = Math.abs(meuKg - top.kg) < 0.0001;
      if (jaEstaNoMelhor) dicaEl.classList.add('cofcof-buybox__dica--vazia');
      else dicaEl.classList.remove('cofcof-buybox__dica--vazia');
    }

    function render() {
      var variant = findVariant(selectedOptions());
      var planId = selectedPlanId();

      /* C11-09 — dois modos de falha, não um.
       *
       * Antes o aviso só aparecia quando a combinação NÃO EXISTIA. Quando ela
       * existia mas estava sem estoque, o botão virava um "Esgotado"
       * desabilitado e nenhuma explicação aparecia: botão morto, sem saída.
       * Medido forçando `available: false` numa variante — `unavailableEl`
       * continuava `hidden`. */
      function avisar(chave) {
        if (!unavailableEl) return;
        var texto = unavailableEl.getAttribute('data-msg-' + chave);
        if (texto) unavailableEl.textContent = texto;
        unavailableEl.hidden = false;
      }

      if (!variant) {
        if (submitEl) submitEl.disabled = true;
        if (submitLabelEl) submitLabelEl.textContent = 'Indisponível';
        avisar('inexistente');
        /* C11-09 — o preço da combinação ANTERIOR não pode ficar na tela.
         * Ele ficava: a função saía antes de tocar no preço, e o quadro exibia
         * R$ 229,90 para uma combinação que não existe. Preço errado numa caixa
         * de compra é a mentira mais cara possível. Fica vazio, e o `role=alert`
         * acima carrega o sentido — nada de travessão, que não distingue
         * "não existe" de "não carregou". */
        if (priceEl) priceEl.textContent = '';
        if (noteEl) noteEl.textContent = '';
        if (volumeEl) { volumeEl.textContent = ''; volumeEl.hidden = true; }
        if (kgEl) { kgEl.textContent = ''; kgEl.hidden = true; }
        if (multEl) { multEl.textContent = ''; multEl.hidden = true; }
        return;
      }

      if (variantInput) variantInput.value = variant.id;
      if (variant.available) {
        if (unavailableEl) unavailableEl.hidden = true;
      } else {
        avisar('indisponivel');
      }

      var price = variant.price;
      if (planId && variant.plans && variant.plans[planId]) price = variant.plans[planId];

      /* C11-09 — o número MAIOR da tela tem de ser o que vai ser cobrado.
       *
       * Medido: com "Quantas assinaturas" em 10, a caixa exibia
       * "R$ 189,90 × 10 por entrega" — o valor real, R$ 1.899,00, não aparecia
       * em lugar nenhum da página. O `× 10` é texto pequeno e cinza ao lado de
       * um número dourado de 28px, e o total só surgia no mini-carrinho,
       * DEPOIS de a compra ter sido feita.
       *
       * A rodada anterior parou em "o multiplicador é dito em texto" com a
       * justificativa de que formatar moeda é trabalho do filtro `money` no
       * servidor. A justificativa não se sustenta: `cofcof-minicart.js` já
       * formata moeda com `toLocaleString` e o resultado bate caractere a
       * caractere com o que a Shopify devolve.
       *
       * Ainda assim o formatador PROVA que serve antes de ser usado: ele
       * reformata o preço unitário e compara com a string que veio do `money`
       * do servidor. Se divergir — outra moeda, outro formato de loja —, a
       * caixa volta ao comportamento anterior em vez de exibir um total num
       * formato que não é o da loja. */
      /* C11-09 rodada 1 — o teto valia no envio e NÃO valia na tela.
       *
       * Medido em /products/cafe-especial-floral-mel, digitando 999 sem sair do
       * campo: a caixa exibia **R$ 42.707,25**, botão habilitado, sem aviso. Ao
       * CLICAR em comprar, o campo se consertava em silêncio para 99 e o
       * carrinho recebia R$ 4.232,25 — mas o preço na tela **continuava
       * R$ 42.707,25**. A divergência sobrevivia à compra: a pessoa via um
       * número dez vezes maior do que o que foi cobrado, e nada na tela dizia
       * que a quantidade havia sido reduzida.
       *
       * A causa é o teto morar em dois lugares que não se falam: o `blur` e o
       * `submit` liam `max`; o `render()` só tinha piso. Agora o teto mora
       * AQUI, no único lugar que decide o que a tela mostra — e o envio, que
       * corrige o campo, manda redesenhar depois de corrigir. */
      var qtd = quantidadeValida();

      // Product weight is in grams; do not parse the option label to infer volume.
      if (volumeEl) {
        var grams = Number(variant.gramas);
        volumeEl.hidden = !(grams > 0 && isFinite(grams));
        volumeEl.textContent = volumeEl.hidden ? '' : (grams * qtd) + ' g no total' + (planId ? ' por entrega' : '');
      }

      var cent = variant.centavos;
      if (planId && variant.plansCent && variant.plansCent[planId]) cent = variant.plansCent[planId];

      var total = null;
      if (qtd > 1 && typeof cent === 'number' && dinheiro(cent) === price) total = dinheiro(cent * qtd);

      if (priceEl) priceEl.textContent = total || price;
      /* A linha RESERVA o lugar mesmo invisível — mesma solução da dica, pela
       * mesma medição: sem reserva, ir de 1 para 2 assinaturas empurrava o botão
       * de comprar 32px para baixo, mais de meia altura do próprio botão, no
       * instante em que a mão sai do campo e vai para ele. Só a visibilidade
       * muda; o texto continua sendo escrito, e o salto é zero por construção.
       *
       * O `hidden` só volta quando a linha não pode existir — sem quantidade
       * confiável ou sem total —, e aí a caixa inteira já está noutro estado. */
      if (multEl) {
        if (typeof cent === 'number' && dinheiro(cent) === price) {
          multEl.textContent = qtd + ' × ' + price;
          multEl.hidden = false;
          if (qtd > 1) multEl.classList.remove('cofcof-buybox__price-mult--vazia');
          else multEl.classList.add('cofcof-buybox__price-mult--vazia');
        } else {
          multEl.textContent = '';
          multEl.hidden = true;
        }
      }

      var sufixo = planId ? 'por entrega' : '';
      /* Sem o total confiável, o multiplicador continua sendo dito ao lado do
       * preço unitário: pior que mostrar o total, melhor que omitir. */
      if (!total && qtd > 1) sufixo = '× ' + qtd + (sufixo ? ' ' + sufixo : '');
      if (noteEl) noteEl.textContent = sufixo;

      /* C11-09 — o preço por quilo acompanha a escolha, e vem PRONTO do
       * servidor: quem formata moeda é o filtro `money` da Shopify. Ele existe
       * porque a opção melhor parecia a pior — 189,90 por 500 g é R$ 379,80/kg,
       * e 229,90 por 1 kg é R$ 229,90/kg. Some quando o peso não está cadastrado,
       * em vez de mostrar uma conta que eu não posso garantir. */
      if (kgEl) {
        var kg = variant.porKg;
        if (planId && variant.plansKg && variant.plansKg[planId]) kg = variant.plansKg[planId];
        if (kg) { kgEl.textContent = kg + '/kg'; kgEl.hidden = false; }
        else { kgEl.textContent = ''; kgEl.hidden = true; }
      }

      marcarEsgotadas();
      dicaDeValor(variant, planId);

      if (submitEl) submitEl.disabled = !variant.available;
      if (submitLabelEl) {
        /* "Esgotado" dizia que o clube inteiro acabou; o que falta é UMA
         * combinação entre oito, e a saída é trocar a moagem. O rótulo agora
         * descreve o que está indisponível, e o aviso acima diz o que fazer. */
        submitLabelEl.textContent = variant.available ? defaultLabel : 'Combinação indisponível';
      }
    }

    form.addEventListener('change', function (event) {
      if (!event.target || event.target.type !== 'radio') return;
      render();
    });

    /* A quantidade também muda o que vai ser cobrado, então ela também redesenha. */
    if (qtyEl) qtyEl.addEventListener('input', render);

    /* C11-09 — normalizar no `blur`, não no `input`.
     * No `input` seria impossível digitar "10": o "1" viraria 1 e o "0" seguinte
     * chegaria num campo já normalizado. No `blur` a pessoa termina de digitar e
     * o campo se conserta sozinho, em vez de guardar um valor inválido até o
     * envio. A guarda do `submit` continua, como última rede. */
    if (qtyEl) {
      qtyEl.addEventListener('blur', function () {
        var corrigido = String(quantidadeValida());
        if (qtyEl.value !== corrigido) { qtyEl.value = corrigido; render(); }
      });
    }

    /* C11-09 — guarda da quantidade, no formulário e não no navegador.
     *
     * O `{% form 'product' %}` sai com `novalidate`, então nem `min="1"` nem
     * `required` disparam mensagem: medido, `checkValidity()` devolvia **true**
     * com o campo VAZIO. E o `cofcof-minicart.js` intercepta o envio e monta o
     * `FormData` na hora — o que estiver no campo vai embora como está.
     *
     * O listener é no FORMULÁRIO, não no documento: assim ele corre antes do
     * handler do minicart, que escuta em `document` na fase de borbulha. */
    if (qtyEl) {
      form.addEventListener('submit', function () {
        var corrigido = String(quantidadeValida()); /* "2,5" e "03" viram 2 e 3 */
        if (qtyEl.value === corrigido) return;
        qtyEl.value = corrigido;
        /* REDESENHAR depois de corrigir. Sem isto, o campo virava 99 e o preço
         * na tela continuava o de 999 — a divergência sobrevivia à compra, que
         * é o pior momento possível para ela existir. */
        render();
      });
    }

    render();
  }

  function boot() {
    var boxes = document.querySelectorAll('[data-cofcof-buybox]');
    for (var i = 0; i < boxes.length; i++) init(boxes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* C11-09 — o Theme Editor troca o HTML da seção sem recarregar a página, e
   * script inserido junto com marcação NÃO é executado pelo navegador. Sem esta
   * linha, a caixa recém-declarada pelo snippet ficaria sem comportamento para
   * quem estiver editando a seção: escolher uma opção não mudaria preço nem
   * variante, e a pessoa concluiria que o tema quebrou. `boot()` é seguro de
   * repetir por causa da marca de idempotência acima. */
  document.addEventListener('shopify:section:load', boot);
})();
